import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";

import { ValidationService } from "../../validation/validation.service";
import { ApiGatewayService } from "../../api-gateway/api-gateway.service";
import { TranslateService } from "../../translate/translate.service";
import { environment } from "environments/environment";

@Component({
	selector: "sdp-delete-account-confirmation",
	templateUrl: "./delete-account.html"
})
export class DeleteAccountConfirmationComponent implements OnInit {

	public deleteForm: FormGroup;
	public isFormSubmitted = false;
	public inProgress = false;
	public errorMessage: string | undefined;
	public accountDeleteConfirmation = "";

	constructor(
		public formBuilder: FormBuilder,
		public validationService: ValidationService,
		private apiGatewayService: ApiGatewayService,
		public dialogRef: MatDialogRef<DeleteAccountConfirmationComponent>,
		@Inject(MAT_DIALOG_DATA)
		public accountName: string,
		private translateService: TranslateService
	) {
		this.deleteForm = this.formBuilder.group({
			confirmation: [
				"",
				Validators.compose([
					Validators.required,
					this.validationService.matchesConstant(this.accountName)
				])
			]
		});
	}

	public ngOnInit() {
		this.accountDeleteConfirmation = this.translateService.translate("account.delete.confirmation", { accountName: this.accountName });
	}

	public async submit() {
		this.errorMessage = undefined;
		this.isFormSubmitted = true;
		if (this.deleteForm.valid) {
			this.inProgress = true;
			try {
				await this.apiGatewayService.deleteAccount();
				localStorage.clear();
				window.location.href = `${environment.REGISTRATION_SITE}/registration/register`;
			} catch (e) {
				this.errorMessage = this.translateService.translate(e);
			}
			this.inProgress = false;
			this.dialogRef.close(true);
		}
	}

	public cancel() {
		this.dialogRef.close(false);
	}

}
